import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the datatable for the casino report.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('league', true); // Current user league parameter

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} Formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            columns: [
                // Column definitions
                {
                    id: 'detailTittle', // Column ID
                    header: '', // Column header
                    width: 50, // Column width
                    height: 25, // Column height
                    tooltip: _('Detalles'), // Tooltip text
                    template: function (obj) {
                        // Template for detail icon
                        return "<span class='webix_icon wxi-close details'></span>";
                    },
                },
                { id: 'Id', header: 'Id', width: 90, sort: 'int' }, // ID column
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Date column
                {
                    id: 'Username',
                    header: _('Usuario'),
                    width: 70,
                    sort: 'int',
                },
                { id: 'Game', header: _('Juego'), width: 150, sort: 'int' }, // Game column
                {
                    id: 'ProviderName',
                    header: _('Proveedor'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Bets', header: _('Apuestas'), width: 80, sort: 'int' }, // Bets column
                {
                    id: 'Stakes',
                    header: _('Valor '),
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    width: 90,
                    sort: 'int',
                },
                {
                    id: 'Winnings',
                    header: _('Premios '),
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    width: 90,
                    sort: 'int',
                },
                {
                    id: 'Profit',
                    header: _('Ganancias '),
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    width: 90,
                    sort: 'int',
                },
                {
                    id: 'Profitness',
                    header: _('Beneficio %'),
                    format: percentFormat, // Percentage formatting
                    width: 100,
                    sort: 'int',
                },
            ],
            onClick: {
                // Event handler for clicking on detail icon
                details: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Pager ID
            // API URL for fetching data
            url: devConfig.geturlApi() + 'null/Report/GetCasinoGamesLeague?League=' + cur_user + '&',
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const cur_user = this.getParam('league', true); // Current user league parameter
        var url = grid.data.url; // Data URL for the grid

        // Event listener for filtering data
        this.on(this.app, 'casinoReportLeague:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters

            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    // Start date
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'MinCreatedLocal=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // End date
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'MaxCreatedLocal=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&LeagueId=' + cur_user; // Append league ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
        });

        // Event listener for item click
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });

        // Event listener for player selection
        this.on(this.app, 'player:select', (id) => {
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + id, // Load data for selected player
            );
        });
    }
}

// FILE DOCUMENTED
